module.exports = __webpack_public_path__ + "static/media/nit.ff8d3af2.png";